import Vue from "vue";
import Router from "vue-router";
// import Home from "./views/Home.vue";
import Projects from "./views/Projects.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "projects",
      component: Projects,
      meta: { rootActive: true}
    },
    {
      path: "/projects",
      name: "projects",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Projects.vue"),
        children: [
          {
            path: "artificiallyesoteric",
            name: "artificiallyesoteric",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/juju.vue")
          },
          {
            path: "onetwenty",
            name: "onetwenty",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/onetwenty.vue")
          },
          {
            path: "creativecloud",
            name: "creativecloud",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/creativecloud.vue")
          },
          {
            path: "adobesocial",
            name: "adobesocial",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/adobesocial.vue")
          },
          {
            path: "destablize",
            name: "Destabilize",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/destabilize.vue")
          },
          {
            path: "ekkos",
            name: "ekkos",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/ekkos.vue")
          },
          {
            path: "indesignnext",
            name: "Idnxt",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/idnxt.vue")
          },
          {
            path: "indesigntouch",
            name: "Intouch",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/idtouch.vue")
          },
          {
            path: "indesign",
            name: "Indesign",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/indesign.vue")
          },
          {
            path: "symbioteI",
            name: "SymbioteOne",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/symbiote.vue")
          },
          {
            path: "symbioteII",
            name: "Symbiotetwo",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/symbiotetwo.vue")
          },
          {
            path: "wastemaker",
            name: "Wastemaker",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "about" */ "./projects/wastemaker.vue")
          }
        ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
}
});

//
//     {
//       path: "/about",
//       name: "about",
//       // route level code-splitting
//       // this generates a separate chunk (about.[hash].js) for this route
//       // which is lazy-loaded when the route is visited.
//       component: () =>
//         import(/* webpackChunkName: "about" */ "./views/About.vue")
//     },
//     {
//       path: "/thesis",
//       name: "thesis",
//       meta: { navHidden: true},
//       // route level code-splitting
//       // this generates a separate chunk (about.[hash].js) for this route
//       // which is lazy-loaded when the route is visited.
//       component: () =>
//         import(/* webpackChunkName: "about" */ "./views/Thesis.vue")
//     },

